
var hotel = [
    [109.642533, 18.234049, '美高梅'],
    [109.634225, 18.233621, '铂尔曼'],
    [109.637250, 18.232274, '万豪'],
    [109.639669, 18.233450, '喜来登'],
    [109.635335, 18.231111, '希尔顿'],
    [109.633035, 18.229377, '丽思卡尔顿'],
    [109.622687, 18.222423, '瑞吉'],
    [109.645378, 18.235197, '红树林'],
    [109.648307, 18.235815, '天域'],
    [109.648814, 18.238937, '和美爵'],
    [109.645180, 18.238253, '五号'],
    [109.641479, 18.242013, '维景'],
    [109.656571, 18.238614, '金棕榈'],
    [109.659625, 18.238803, '天鸿'],
    [109.661727, 18.241206, '星华'],
    [109.661096, 18.241926, '仙人掌'],
    [109.617638, 18.194966, '柏悦'],
    [109.535106, 18.227306, '哈曼度假酒店'],
    [109.751285, 18.362061, '亚特兰蒂斯'],
    [109.741962, 18.336113, '索菲特'],
    [109.727877, 18.291838, '九号'],
    [109.744585, 18.345155, '红树林'],
    [109.746202, 18.350508, '君悦'],
    [109.748897, 18.356582, '香格里拉'],
    [109.756263, 18.371404, '艾迪逊'],
    [109.757513, 18.373964, '威斯汀'],
    [109.757664, 18.373977, '半山半岛'],
    [109.436913, 18.297314, '丽禾温德姆'],
    [109.386837, 18.294550, '皇冠假日'],
    [109.755526, 18.368634, '仁恒皇冠假日'],
    [109.544015, 18.217124, '文华东方'],
    [109.544015, 18.217124, '文华东方'],
    [109.661938, 18.239412, '星华华邑'],
    [109.664959, 18.238321, '海景国际'],
    [109.663041, 18.238191, '爱琴海'],
    [109.738935, 18.324702, '保利瑰丽'],
    [109.448219, 18.295435, '国光豪生'],
    [109.500057, 18.234671, '玛瑞纳'],
    [109.791201, 18.406291, '万丽'],
    [109.758648, 18.380137, '天房'],
    [109.436913, 18.297314, '温德姆'],
    [109.871242, 18.399872, '莱福士'],
    [109.892980, 18.413446, '金普顿'],
    [109.895582, 18.414534, '威博斯'],
    [109.959972, 18.420571, '威斯汀'],
    [110.111813, 18.533345, '万豪'],
    [110.115442, 18.539050, '悦海'],
    [110.181135, 18.589878, '华邑'],
    [110.288442, 18.672760, '威斯汀'],

]


var sanya = [
    {
        name: '酒店',
        group: 'base',
        list: hotel,
        show: true,
        color: 'plum'
    }
]

export default sanya